import * as actionType from './types';
import axios from '../../../common/config/axios';

export const getList = (props = {}) => (dispatch) => 
{
    const { activePage, limit, ...rest } = props;
    const params = {
      page: activePage || 1,   // Laravel paginator expects `page`
      limit: limit || 10,
      ...rest,                 // e.g. start_date, end_date, game_type, country_id, etc.
    };

    
   return axios
    .get('instant_rebate/list', { params })
    .then((response) => {
      dispatch({
        type: actionType.LIST,
        value: response.data,
      });
    })
    .catch((err) => {
      console.error('Axios request failed:', err);
    });
};
 
export const getTotalInstantRebate = (res_data) => dispatch => {
   return axios.get('instant_rebate/calculate', res_data)
        .then( (response) => {
            //Dispatch to the reducers
            dispatch ({
                //Type is based on types.js name you created
                type: actionType.CALCULATE,
                payload: response.data
            })
        }).catch (err => {
        dispatch ({
            type: actionType.CALCULATE,
            // payload: {"rst":"0","msg":"system_error"}
            payload: err
        })
    })
};

export const claimAll = (payload = {}) => (dispatch) => {
  return axios
    .post('instant_rebate/claim', payload)
    .then((response) => {
      dispatch({ type: actionType.CLAIM_SUCCESS, value: response.data });
      // Refresh page 1 after claim
      dispatch(getList({ activePage: 1, limit: 10 }));
      return response.data;
    })
    .catch((err) => {
      dispatch({ type: actionType.CLAIM_FAIL, value: err });
      throw err;
    });
};

export const getHistory = (props) => (dispatch) => {
  return axios
    .get('instant_rebate/history', { params: props })
    .then((response) =>
      dispatch({ type: actionType.HISTORY, value: response.data })
    )
    .catch((err) => console.error('Axios request failed:', err));
};

export const getHistoryByTransaction = (props = {}) => (dispatch) => {
  // expects: transaction_id, member_id, merchant_id, country_id, activePage, limit
  return axios
    .get('instant_rebate/history_by_transaction', { params: props })
    .then((response) => {
      dispatch({ type: actionType.HISTORY_BY_TRANSACTION, value: response.data });
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
};